import getValue from './keyvalue/selectors/getValue';

export const BASENAME_KEY = '_widget_basename';

export const getBasename = getValue(BASENAME_KEY);
